import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-puntos-grafica',
  templateUrl: './puntos-grafica.component.html',
  styleUrls: ['./puntos-grafica.component.scss']
})
export class PuntosGraficaComponent implements OnInit {
  @Input() dataGrafica:any;
 // chartOptions = {};
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    series: [{
      data: [1, 2, 3],
      type: 'line'
    }]
  };
  
  constructor() { }



  ngOnInit(): void {
    console.log(' this.dataGrafica', this.dataGrafica);
    

    this.chartOptions ={
      chart: {
          type: 'column'
      },
      title: {
        text: 'Últimos ingresos',
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: this.dataGrafica.serie,
        crosshair: true
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Número de ingresos'
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
    },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0
        }
    },
    series: [{
      type: 'column',
        name: 'Ingresos permitidos',
        data: this.dataGrafica.permitidos

    }, {
      type: 'column',
        name: 'Ingresos no permitidos',
        data: this.dataGrafica.noPermitidos

    }]
  }; 
 
  //  HC_exporting(this.Highcharts);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

}
